module.exports = __webpack_public_path__ + "media/images/emblems/Zuzgen-blason-4e56f19f57501826b0ec80eeb8774be7.png";